import { type GetInvitedUser } from '@api/user/types';

import { userModel } from '../userModel';
import { type InvitedUser } from './types';

/**
 * Model to transform invited user data
 */
export const invitedUserModel = ({
  mobile,
  selectedCountry,
  phonePrefix,
  ...user
}: GetInvitedUser): InvitedUser => ({
  ...userModel(user),
  mobile: mobile ?? '',
  phonePrefix: phonePrefix ?? '',
  selectedCountry: selectedCountry ?? null,
});
